import type { PdfViewerClickableAreaProps } from "./pdf-viewer-clickable-area.type";

import { usePdfViewerClickableArea } from "./pdf-viewer-clickable-area.hook";

import "./pdf-viewer-clickable-area.style.less";

export const PdfViewerClickableArea = (props: PdfViewerClickableAreaProps) => {
  const { areaRef, onAreaClick } = usePdfViewerClickableArea(props);

  return (
    <div
      ref={areaRef}
      onClick={onAreaClick}
      className="pdf-viewer-clickable-area"
      data-testid="pdf-viewer-clickable-area"
    />
  );
};
